module.exports = __webpack_public_path__ + "fade2e6c6ffd4958b9e8d8fdb30cb744.png";